import cloneDeep from 'lodash/cloneDeep'

import { AbstractRequestModel } from './Request'
import { SearchResult } from '@/models/Repository'
import AgencyMarginRequestApi from '../api/AgencyMarginRequest'
import AgencyMarginApi from '../api/AgencyMargin'
import { AgencyMarginModel } from '@/models/AgencyMargin'

export class AgencyMarginRequest extends AbstractRequestModel {
  constructor(params) {
    super(params)
    const {
      agencyId,
      agencyMarginId,
      name,
      agencyName,
      marginValue,
      startDate,
      endDate,
    } = params

    this.agencyId = Number(agencyId) || undefined
    this.agencyMarginId = Number(agencyMarginId) || undefined
    this.name = name
    this.agencyName = agencyName
    this.marginValue = marginValue
    this.startDate = startDate
    this.endDate = endDate

    this.agencyMargin = null
  }

  clone() {
    return cloneDeep(this)
  }

  async getAgencyMargin() {
    if (!this.agencyMarginId) return Promise.reject(null)
    try {
      const result = await AgencyMarginApi.fetch(this.agencyMarginId)
      return new AgencyMarginModel(result.item)
    } catch (e) {
      console.error(e)
      throw new Error('代理店マージンの取得に失敗しました')
    }
  }

  async fetchAgencyMargin() {
    if (!this.agencyMarginId) return
    this.agencyMargin = await this.getAgencyMargin()
  }

  async approve() {
    const { name, note } = this
    const requestStatus = 'approved'
    return await AgencyMarginRequestApi.update(this.id, {
      name,
      requestStatus,
      note,
    })
  }

  /**
   * @param {string} reason 却下理由
   */
  async reject(reason) {
    const { name, note } = this
    const requestStatus = 'rejected'
    return await AgencyMarginRequestApi.update(this.id, {
      name,
      requestStatus,
      reason,
      note,
    })
  }
}

export class AgencyMarginRequestRepository {
  static async search({
    systemOwnerId,
    requestStatus,
    keyword,
    sortBy,
    descending,
    pageNo,
    pageSize,
  } = {}) {
    const res = await AgencyMarginRequestApi.search({
      query: {
        systemOwnerId,
        keyword,
        requestStatus,
      },
      pageSize,
      pageNo,
    })
    const items = res.items
      .map(item => new AgencyMarginRequest(item))
      .sort((a, b) => {
        if (a[sortBy] > b[sortBy]) {
          return descending ? 1 : -1
        } else if (a[sortBy] < b[sortBy]) {
          return descending ? -1 : 1
        }
        return 0
      })
    return new SearchResult({
      count: res.count,
      pageNo: res.pageNo,
      pageSize,
      items,
    })
  }

  static async bulkApprove(ids) {
    // TODO: API コール
    return Promise.resolve(ids.length > 0)
  }

  static async cancelRequest(id) {
    try {
      await AgencyMarginRequestApi.delete(id)
    } catch (e) {
      console.error(e)
      throw new Error('申請を取り消せませんでした')
    }
  }
}
